import React from 'react'

const webExtensions = [
  {
    question: 'What Internet browsers do you support?',
    answer: (
      <>
        Currently TAYL has official extensions for{' '}
        <a
          href="https://addons.mozilla.org/en-US/firefox/addon/tayl-website-to-podcast/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Mozilla Firefox
        </a>{' '}
        and{' '}
        <a
          href="https://chrome.google.com/webstore/detail/dnnlphagnbdccldakkjehjdideaobidd"
          rel="noopener noreferrer"
        >
          Google Chrome
        </a>
        . Microsoft Edge is on the roadmap, and will be added shortly!
      </>
    ),
  },

  {
    question: 'How do I sign in to the extension?',
    answer:
      'Activate the extension in your browser (click the TAYL icon), then press "Sign in". If you use Chrome you will be signed in automatically. If not, you will have to copy & paste your API Key.',
  },

  {
    question: 'What features can I use?',
    answer:
      'If you are a free user, you can use the TAYL browser to improve radability of web pages. Additionally, if you are a TAYL subscriber you can send content to your TAYL account to have it read. Standard quota applies.',
  },

  {
    question: 'How do I sync my settings?',
    answer:
      'The extension will automatically sync your settings across computers, if you are signed in to your web browser and have activated profile sync.',
  },
]

export default webExtensions
